import { render } from "./About.vue?vue&type=template&id=9a1726a2"
const script = {}
script.render = render

export default script